
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb:'ธุรกรรมเหรียญ',
    bba:'บัญชีเหรียญ',
    hy:'ธุรกรรมสัญญา',
    jg:'สัญญาการส่งมอบ',
    hya:'บัญชีสัญญา'
  },
  index: {
    h24: 'ปริมาณ 24H',
    header_title: ['เลือกการซื้อขายสินทรัพย์ดิจิทัล ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'ทำธุรกรรมสินทรัพย์ดิจิทัล blockchain แบบครบวงจรให้เสร็จสิ้น',
    header_msg: 'ปลอดภัย-มั่นคง-เชื่อถือได้',
    register_title: 'ลงทะเบียน ' + window.GLOBAL.LANG_TITLE.zh + ' บัญชีทั่วโลกเริ่มต้นเส้นทางการซื้อขาย',
    register_pl: 'กรุณากรอกอีเมลหรือโทรศัพท์มือถือของคุณ',
    register: 'ลงทะเบียน',
    featureTitleWhy: 'ทำไมถึงเลือกพวกเรา',
    featureTitle: 'ปลอดภัย · มั่นคง · เชื่อถือได้',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'เทคโนโลยีกระเป๋าสตางค์ที่ปลอดภัย', msg: ['เทคโนโลยีกระเป๋าสตางค์เย็นและร้อนได้รับการพัฒนาโดยทีมรักษาความปลอดภัยชั้นนำของโลก และไม่เคยมีเหตุการณ์การสูญหายของเหรียญมาก่อน。',''] },
      { icon: icon2, title: 'ธุรกิจสินทรัพย์ crypto ที่ร่ำรวย', msg: ['Support spot และการซื้อขายอนุพันธ์หลายตัว ฯลฯ เป็นผู้ดูแลส่วนตัวของคุณในโลกของสินทรัพย์ที่เข้ารหัส',''] },
      { icon: icon3, title: 'ลูกค้ากระจายไปทั่วโลก', msg: ['ให้บริการสินทรัพย์ที่เข้ารหัสอย่างเต็มรูปแบบสำหรับผู้ใช้ในกว่า 130 ประเทศหรือภูมิภาคทั่วโลก', ''] }
    ],
    bannerList: [
      {icon: banner01,title: "มุ่งมั่นที่จะมอบการรักษาความปลอดภัยและความมั่นคงระดับแนวหน้าของอุตสาหกรรม", msg: ["สัญญาที่ชาญฉลาดเพื่อปกป้องความปลอดภัยของทรัพย์สินของนักลงทุน", "ประสิทธิภาพการซื้อขายจริง", "การรับประกันบริการตลอด 24 ชั่วโมง"] },
      {icon: banner02,title: "ฉันต้องการซื้อและขายทันทีผ่านการดำเนินการง่ายๆ", msg: ["หน้าจอการซื้อขายอย่างง่าย", "สะท้อนให้เห็นในยอดเงินในบัญชีของคุณทันที", "สกุลเงินดิจิทัลส่วนใหญ่สามารถซื้อขายได้" ] },
      {icon: banner03,title: "ฉันต้องการรับผลกำไรจากการซื้อขายสัญญายุติคดี", msg: ["เปิดบัญชีพร้อมกัน", "การลงทุนเชิงกลยุทธ์สำหรับการซื้อขายฟิวเจอร์สจำนวนมาก", "คุณสามารถซื้อขายได้ 24 ชั่วโมงต่อวัน 365 วันต่อปี แม้ในวันหยุดสุดสัปดาห์"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["การใช้ลักษณะของ blockchain และ smart contracts, การตระหนักถึงประสิทธิภาพการทำธุรกรรมใน chain และการใช้ smart contract เพื่อความปลอดภัยของทรัพย์สินของนักลงทุน",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["ด้วยกลยุทธ์ที่หลากหลายซึ่งจัดทำโดยผู้เชี่ยวชาญด้านการซื้อขายเชิงปริมาณชั้นนำ คุณสามารถเลือกได้อย่างอิสระ",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["ออกแบบผลิตภัณฑ์การลงทุนที่หลากหลายโดยพิจารณาจากความเสี่ยงที่แตกต่างกันและการตั้งค่าการจัดการสินทรัพย์ของนักลงทุนแต่ละราย ขจัดเกณฑ์การลงทุนอย่างมีประสิทธิภาพ", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["มีความต้องการการลงทุนของผู้ใช้หลายประเภทและกลไกแพลตฟอร์มที่ยืดหยุ่น และยังคงผลิตบริการทางการเงินที่เป็นนวัตกรรมใหม่ที่ดีกว่าตลาด", ""]}
    ],
    featureTitle2: 'ธุรกรรมเทอร์มินัลหลายแพลตฟอร์มทุกที่ทุกเวลา',
    featureMsg2: 'ครอบคลุมหลายแพลตฟอร์มของ iOS และ Android รองรับฟังก์ชั่นบริการเต็มรูปแบบ',
    tab: ['เหรียญกระแสหลัก', 'รายการเพิ่มขึ้น 24 ชั่วโมง'],
    thead: ['ชื่อ', 'ราคาล่าสุด', 'ราคาสูงสุดของวัน', 'ต่ำสุดของวัน','รายการที่เพิ่มขึ้น', 'ระดับเสียง 24 ชั่วโมง','การทำงาน'],
    more: 'ดูเพิ่มเติม >',
    btn: 'ธุรกรรม',
    dealsTitle: 'บริการซื้อขายแบบครบวงจร',
    dealsTab:[
      { title: 'สกุลเงินซื้อขาย', content: 'การซื้อขายสกุลเงินเป็นการแลกเปลี่ยนระหว่างสินทรัพย์ดิจิทัล โดยใช้ USDT เป็นหน่วยในการประเมินมูลค่าเพื่อซื้อสกุลเงินอื่น '+window.GLOBAL.LANG_TITLE.zh+'ธุรกรรมสกุลเงินรองรับการทำธุรกรรมแบบเรียลไทม์ของสินทรัพย์ดิจิทัล เช่น Bitcoin, Ethereum และ Litecoin', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'สัญญาการซื้อขาย', content: 'อนุพันธ์ทางการเงินของสกุลเงินดิจิทัลไม่เพียงแต่สนับสนุนทางเลือกในการซื้อสัญญาขายยาวหรือชอร์ตเพื่อสร้างรายได้เท่านั้น แต่ยังดำเนินการได้ง่ายและไม่มีวันหมดอายุอีกด้วย '+window.GLOBAL.LANG_TITLE.zh+'สัญญามีระบบการจัดการความเสี่ยงขั้นสูงพร้อมเลเวอเรจสูงถึง 100 เท่า ', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['เลือกเอง', 'สัญญา', 'เหรียญ'],
    thead: ['สกุลเงิน', 'ราคาล่าสุด', 'การเปลี่ยนแปลง 24 ชั่วโมง', 'ต่ำสุด 24 ชั่วโมง', 'สูงสุด 24 ชั่วโมง', 'ระดับเสียง 24 ชั่วโมง', 'การทำงาน'],
    nodata: 'ไม่มีข้อมูล'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "เกี่ยวกับเรา",
        dd: [{ title: "ข้อมูลบริษัท", id: 1 }, { title: "ศูนย์ช่วยเหลือ", type: 'help' }]
      },
      {
        dt: "การสนับสนุนผู้ใช้",
        dd: [
          { title: "ข้อตกลงการใช้", id: 3 },
          { title: "นโยบายความเป็นส่วนตัว", id: 5 }
        ]
      },
      {
        dt: "ติดต่อเรา",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["เข้าสู่ระบบ", "ลงทะเบียน", "การจัดการสินทรัพย์","ดาวน์โหลดAPP"],
    nav: [
      { title: "หน้าแรก", path: "/index",name: 'index' },
      { title: "ตลาด", path: "/market",name: 'market' },
      // { title: "ธุรกรรมสกุลเงิน", path: "/deal", name: 'deal'},
      // { title: "รายการตามสัญญา", path: "/deal_c", name: 'deal_c' },
      { title: "สัญญาการส่งมอบ", path: "/deal_jg", name: 'deal_jg' },
      { title: "การถือส่วนลด", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "ทรัพย์สินของฉัน", path: "/asset" }],
    menus: [
      { icon: langzh, title: "ศูนย์ผู้ใช้", path: "/setting" },
      { icon: langen, title: "ออกจากระบบ" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "ดาวน์โหลด"
  },
  // 登录
  login: {
    login: 'กรุณาเข้าสู่ระบบ',
    msg: 'กรุณาใส่บัญชีที่ลงทะเบียนของคุณ',
    list: ['มือถือ/อีเมล', 'รหัสผ่าน', 'ลืมรหัสผ่านใช่หรือไม่', 'เข้าสู่ระบบ', 'ไม่มีบัญชี ลงทะเบียนเลย'],
    message: 'ต้องระบุบัญชีหรือรหัสผ่าน'
  },
  register: {
    dl: ['การลงทะเบียนมือถือ','การลงทะเบียนอีเมล'],
    title: 'ลงทะเบียนบัญชี',
    country: 'ประเทศที่คุณถือสัญชาติอยู่',
    country_info: 'ข้อมูลสัญชาติไม่สามารถแก้ไขได้หลังจากลงทะเบียนแล้ว โปรดเลือกตามความเป็นจริง择',
    account: 'หมายเลขบัญชี',
    code_text: 'รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_unit: 's',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',
    pid_text: 'รหัสการเชิญ',
    pid_pl: 'ไม่จำเป็น',
    invitation_code_no_data: 'ต้องระบุรหัสเชิญ',
    xy: 'ข้อตกลงการใช้',
    xy_no_checked: 'กรุณาเลือกข้อตกลง',
    agree: 'ฉันได้อ่านและตกลง',
    register_btn: 'ลงทะเบียน',
    bz: ['ข้อมูลสัญชาติไม่สามารถแก้ไขได้หลังจากลงทะเบียนแล้ว โปรดตรวจสอบให้แน่ใจว่าได้เลือกตามความเป็นจริง ','อีเมลยืนยันอาจถูกตัดสินว่าเป็นสแปมอย่างไม่ถูกต้อง โปรดตรวจสอบอย่างละเอียด ','โปรดรักษาบัญชีของคุณให้ถูกต้อง' + window.GLOBAL.LANG_TITLE.zh +'บัญชีและรหัสผ่านสำหรับเข้าสู่ระบบ ','อย่าใช้รหัสผ่านเข้าสู่ระบบเดียวกันกับเว็บไซต์อื่น '],
    account_no_data: 'บัญชีต้องไม่เว้นว่าง',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน'
  },
  // 设置密码
  bindmpwd: {
    title: 'ตั้งรหัสผ่าน',
    account: 'หมายเลขบัญชี',
    code_text: 'รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_unit: 's',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน',
    bindmpwd_btn: 'ยืนยัน',
    phone_no_data: 'หมายเลขโทรศัพท์ไต้องไม่เว้นว่าง',
    password_login_text: 'โปรดใส่รหัสผ่านของคุณ',
    password_trade_text: 'ความยาวรหัสผ่าน 6 หลัก',
    password_again_tarde_text: 'ความยาวรหัสผ่าน 6 หลัก',
  },
  // 忘记密码
  forgetpwd: {
    title: ['แก้ไขรหัสผ่าน', 'ลืมรหัสผ่าน'],
    account: 'หมายเลขบัญชี',
    code_text: 'รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_unit: 's',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',

    phone_no_data: 'หมายเลขโทรศัพท์ไต้องไม่เว้นว่าง',

    account_no_data: 'บัญชีต้องไม่เว้นว่าง',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน',
    forgetpwd_btn: 'ยืนยัน'
  },
  // 绑定手机号码
  bindphone: {
    title: 'ผูกเบอร์มือถือ',
    phone_text: 'หมายเลขโทรศัพท์',
  },
  person: {
    more: 'โหลดเพิ่ม',
    no_more: 'ไม่มีข้อมูลอีกต่อไป',
    index_center:"ศูนย์ผู้ใช้",
    index_menus: [
      { icon: zhsz, title: "การจัดการบัญชี", path: '/setting' },
      { icon: sfrz, title: "การรับรองความถูกต้อง KYC", path: '/sfyz' },
      { icon: sfrz, title: "การรับรองระดับเบื้องต้น", path: '/smauth' },
      { icon: sfrz, title: "ตรวจสอบแล้ว", path: '/seniorauth' },
      { icon: jtrz, title: "การตรวจสอบที่อยู่", path: '/dzrz' },
      { icon: jtrz, title: "ซื้อเหรียญรวดเร็ว", path: '/kjmbSelect' },
      { icon: jtrz, title: "คะแนนเครดิต", path: '/credit' },
      { icon: jtrz, title: "บันทึกบัญชี", path: '/deallog' },
      { icon: jtrz, title: "บันทึกการฝาก", path: '/cbjl' },
      { icon: jtrz, title: "บันทึกการถอน", path: '/tbjl' },
    ],
    cbtb: 'ฝากและถอน',
    jymx: 'รายละเอียดการทำธุรกรรม',
    xyf: {
      'title': 'คะแนนเครดิต',
      'pgsj': 'เวลาประเมิน'
    },
    smrz:{
       title:'ตรวจสอบแล้ว' ,
       sure_title:'คุณได้ผ่านการพิสูจน์ตัวตนด้วยชื่อจริงแล้ว',
       zj_type:'ประเภทบัตร' ,
       zj_info:['1, ไม่สามารถแก้ไขข้อมูลการรับรองความถูกต้องได้เมื่อตรวจสอบแล้ว กรุณากรอกตามความเป็นจริง','2, ไม่สามารถตรวจสอบข้อมูลชื่อจริงที่ตรวจสอบความถูกต้องอีกครั้งได้'],
       zj_name:'ชื่อ' ,
       zj_num:'หมายเลขประจำตัวประชาชน' ,
       zj_btn:'ตกลง' ,
       zj_rebtn:'ยืนยันอีกครั้ง' ,
       zj_sebtn:'การตรวจสอบขั้นสูง' ,
       zj_type_array:[{name:'บัตรประจำตัวประชาชน',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "บัตรประจำตัวประชาชน"
        },
        {
            id: 2,
            name: "หนังสือเดินทาง"
        },
        {
            id: 3,
            name: "ใบขับขี่"
        },
        {
            id: 4,
            name: "ใบอนุญาตมีถิ่นที่อยู่"
        },
        {
            id: 5,
            name: "อื่นๆ"
        }
       ],
       zj_data:{city:'สัญชาติไม่สามารถเว้นว่างได้',type:'ต้องระบุประเภทข้อมูลรับรอง',name:'ชื่อต้องไม่เว้นว่าง',zj_num:'หมายเลขประจำตัวประชาชนต้องไม่เว้นว่าง'},
       zsxm: 'ชื่อจริง',
       qsrzsxm: 'กรุณาใส่ชื่อจริงของท่าน',
       zjlx: 'ประเภทบัตร',
       qxzzjlx: 'โปรดเลือกประเภทบัตร',
       sfz: 'บัตรประจำตัวประชาชน',
       zjhm: 'หมายเลขประจำตัวประชาชน',
       qsrzjhm: 'โปรดใส่หมายเลขประจำตัวประชาชน',
       sczjz: 'อัพโหลดรูปบัตรประชาชน',
       zjzm: 'โปรดอัพโหลดด้านหน้าของบัตรประชาชน',
       zjfm: 'โปรดอัพโหลดด้านหลังของบัตรประชาชน',
       qsczjzm: 'กรุณาอัปโหลดรูปถ่ายด้านหน้าของบัตรประจำตัวของคุณ',
       qsczjfm: 'กรุณาอัพโหลดรูปถ่ายด้านหลังบัตรประจำตัวของคุณ',
       scqmz: 'โปรดอัพบัตรประชาชนและลายเซ็น',
       qscscqmz: 'กรุณาอัปโหลดรูปถ่ายประจำตัวและลายเซ็นส่วนตัวของคุณ',
       zj: [
         {
           id: 1,
           title: 'บัตรประจำตัวประชาชน'
         },
         {
           id: 2,
           title: 'หนังสือเดินทาง'
         },
         {
           id: 3,
           title: 'อื่นๆ'
         },
       ],
       tj: 'ส่ง',
       shz: 'กำลังตรวจสอบ',
       shtg: 'ผ่านการตรวจสอบ'
    },
    gjrz:{
      title:'ใบรับรองระดับอาวุโส',
      zj_info:['1. รองรับรูปภาพรูปแบบ JPG, JPEG หรือ PNG ที่เล็กกว่า 8M ','2. รูปถ่ายต้องชัดเจน ห้ามดัดแปลงหรือกีดขวาง และต้องมองเห็นภาพบุคคล หมายเลข ID และชื่อให้ชัดเจน ','3. รูปภาพต้องไม่มีฝาปิด ขอแนะนำว่าไม่จำเป็นต้องแต่งหน้า ให้มองเห็นใบหน้าของบุคคลที่ถือบัตรประจำตัวได้ชัดเจน และแขนเปลือยโดยสมบูรณ์'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'ตั้งค่าความปลอดภัย',
      bind:[{bind_title:'รีเซ็ตรหัสผ่าน',bind_name:'กล่องจดหมาย'},{bind_title:'ตั้งรหัสผ่านการทำธุรกรรม',bind_name:'กล่องจดหมาย'}]
    },
    wdtg:{
      own_code:'รหัสเชิญพิเศษ',
      own_code_url:'การเชื่อมต่อคำเชิญพิเศษ',
      own_push_title:'การโปรโมตของฉัน',
      own_push_content:['รายได้คำเชิญทั้งหมด (การประเมินค่า)', 'จำนวนคำเชิญ', 'ผู้คน'],
      own_push_content_profit:['ผลประโยชน์การเชิญระดับ 1','ผลประโยชน์การเชิญระดับ 2','ผลประโยชน์การเชิญระดับ 3','ผลประโยชน์การเชิญระดับ 4'],
      own_push_content_num:['จำนวนคำเชิญที่ระดับแรก','จำนวนคำเชิญที่ระดับที่สอง','จำนวนคำเชิญที่ระดับที่สาม','จำนวนคำเชิญที่ระดับที่สี่'],
      own_push_profit_title: ['ID','profit','หมายเหตุข้อมูล','เพิ่มเวลา'],
      own_push_num_title: ['ID','name','phone','add time'],
    },
    jyzt_td: ['เวลา', 'รายละเอียด', 'จำนวน'],
    cbjl_td: ['เวลา', 'สกุลเงิน', 'ปริมาณ', 'สถานะ'],
    sfrz_txt: ['การตรวจสอบตัวตน', 'คุณได้ส่งการตรวจสอบแล้ว โปรดรอผล', 'คุณผ่านการตรวจสอบขั้นสูงแล้ว', 'ด้านหน้าของบัตรประจำตัว', 'ด้านหลังบัตรประจำตัว', 'การตรวจสอบสิทธิ์',' การตรวจสอบสิทธิ์ล้มเหลว โปรดยืนยันอีกครั้ง' ],

    zhsz_txt: ['ระดับความปลอดภัยของบัญชีของคุณ: #','ระดับความปลอดภัยของบัญชีของคุณ: # ปรับปรุงข้อมูลเพิ่มเติมและรับรองความปลอดภัยของบัญชี'],
    zhsz_m:'แข็งแกร่ง',
    zhsz_n:'อ่อนแอ',
    zhsz_p:'ไม่ปลอดภัย',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'ใส่รหัสผ่าน', value: 'บัญชีอินเทอร์เน็ตมีความเสี่ยงที่จะถูกขโมย ขอแนะนำให้คุณเปลี่ยนรหัสผ่านเป็นประจำเพื่อป้องกันความปลอดภัยของบัญชีของคุณ',value2:'', btn: 'แก้ไข',bind_email:'กรุณาผูกอีเมลหรือโทรศัพท์มือถือของคุณก่อน', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'รหัสผ่านการทำธุรกรรม', value: 'ตั้งรหัสผ่าน', btn: 'ไปที่ set', path: '/bindmpwd' }
    ],
    sksz_txt: ['การตั้งค่าใบเสร็จ', 'บันทึก'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'หน้าแรก',
    prev: 'หน้าก่อน',
    next: 'หน้าต่อไป',
    last: 'หน้าสุดท้าย',
    no_data: 'ไม่มีข้อมูล',
  },
  asset: {
    title: 'ทรัพย์สินของฉัน',
    zjhz: 'การโอนเงิน',
    cb: 'ฝากเงิน',
    gz: 'การประเมินมูลค่า USDT',
    atnv: [],
    zh_title: 'สินทรัพย์ทั้งหมดที่แปลงแล้ว: ',
    index_title: 'ทรัพย์สิน',
    address_title: 'สกุลเงิน',
    address_txt: ['กรุณาเลือก','ที่อยู่ถอน','โปรดป้อนเนื้อหา','หมายเหตุ','รายการที่อยู่'],
    address_btn: ['เพิ่ม', 'บันทึก', 'ลบ', 'แก้ไข'],
    address_td: ['สกุลเงิน', 'ที่อยู่ถอนเงิน', 'หมายเหตุ', 'การดำเนินการ'],
    currency_td: ['สกุลเงิน', 'พร้อมใช้งาน', 'แช่แข็ง', 'แปลงแล้ว'],

    table_title: 'สินทรัพย์รวม: ',
    table_address_title: 'การจัดการที่อยู่ถอน',
    table_td: ['สกุลเงิน', 'ใช้ได้', 'ตรึง', 'แปลง', 'การทำงาน'],
    table_btn: ['ฝากเหรียญ', 'ถอนเหรียญ' ,'บันทึก','โอน'],

    money_text: ['ที่อยู่ถอน', 'โปรดเลือก', 'จำนวน', 'ใช้ได้:', 'ค่าธรรมเนียมการจัดการ',
    'จำนวนที่มาถึง', 'รหัสผ่านการทำธุรกรรม', 'ป้ายกำกับ (บันทึก)', 'การถอนขั้นต่ำ'],
    money_btn: 'ถอนเงิน',
    xzbz: 'เลือกสกุลเงิน',
    money_msg: ['เตือนความจำที่อบอุ่น', '1. เวลาถอนคือ 12:00-24:00 น. ตามเวลาฮ่องกง โดยมีการถอน 2 ครั้งต่อวัน (ถอนขั้นต่ำ 100u ถอนสูงสุด 200,000u);', '2. ปัจจุบันการถอนเท่านั้น รองรับสกุลเงิน USDT และประเภทลิงค์กระเป๋าเงินคือ ERC20;','3. หลังจากส่งใบสมัครถอนเงินแล้ว เงินจะอยู่ในสถานะถูกระงับเนื่องจากการถอนเงินอยู่ในระหว่างดำเนินการ และเงินได้รับการจัดการชั่วคราวโดยระบบและไม่สามารถระงับได้ โดยคุณ อิสระในการควบคุม ไม่ได้หมายความว่าคุณสูญเสียทรัพย์สินหรือทรัพย์สินผิดปกติ โปรดรออย่างอดทนเพื่อรอการอนุมัติ','4. เวลาที่มาถึงหลังจากส่งคำขอถอนเงินจะขึ้นอยู่กับเวลายืนยันการบล็อก หากไม่คาดว่าจะถอนตัวหลังจากเวลาถอนตัว โปรดปรึกษาฝ่ายบริการลูกค้าเพื่อสอบถามข้อมูล',' 5. เพื่อป้องกันการตั้งค่าพฤติกรรมปัจจุบัน 90% ของจำนวนเงินที่ใช้ทั้งหมดจะต้องเริ่มต้นการถอน'],

    recharge_title: 'ที่อยู่เติมเงิน',
    recharge_btn: ['คัดลอก', 'รหัส QR', 'เติมเงิน'],
    recharge_text: ['ปริมาณ', 'การแจ้งเตือนอย่างอบอุ่น', 'อย่าเติมเงินสินทรัพย์ที่ไม่ใช่ USDT ไปยังที่อยู่ด้านบน มิฉะนั้น สินทรัพย์จะไม่ถูกเรียก ','เงินฝาก USDT รองรับเฉพาะวิธีการส่งแบบธรรมดา การฝากโดยใช้วิธีอื่น (ส่งทั้งหมด) ไม่สามารถโพสต์ได้ชั่วคราว โปรดเข้าใจ ','ข้อมูลรับรอง' ,'บรรยาย(ไม่จำเป็น)' ,'ชื่อเชน'],

    record_title: 'บันทึกทางการเงิน',
    record_td: ['ปริมาณ', 'บันทึก', 'เวลา'],

    transfer_title: 'โอน',
    transfer_btn: ['ทั้งหมด', 'โอน'],
    transfer_text: ['จาก', 'ถึง', 'โปรดป้อนจำนวนเงินที่โอน', 'มี:'],
    "bq": "ป้ายกำกับ (บันทึก)",
    "qsrbq": "กรุณาใส่ป้ายกำกับ",
    "yhktx": "ถอนบัตรธนาคาร",
    "yhmc": "ชื่อธนาคาร",
    "qsryhmc": "โปรดใส่ชื่อธนาคาร",
    "yhzh": "บัญชีธนาคาร",
    "qsryhzh": "โปรดใส่เลขบัญชีธนาคาร",
    "gjhkdm": "รหัสโอนเงินระหว่างประเทศ",
    "qsrgjhkdm": "โปรดใส่รหัสโอนเงินระหว่างประเทศ",
    "yhdz": "ที่อยู่ธนาคาร",
    "qsryhdz": "โปรดใส่ที่อยู่ธนาคาร",
    "skrxm": "ชื่อผู้รับเงิน",
    "qsrskrxm": "โปรดใส่ชื่อผู้รับเงิน",
    "skrdh": "โทรศัพท์ผู้รับเงิน",
    "qsrskrdh": "โปรดใส่หมายเลขโทรศัพท์ผู้รับเงิน",
    "skrdz": "ที่อยู่ผู้รับเงิน",
    "qsrskrdz": "โปรดใส่ที่อยู่ผู้รับเงิน"
  },
  text: {
    btn: 'กลับ',
    login: 'กรุณาเข้าสู่ระบบก่อน'
  },
  deal: {
    chooseType: 'ประเภทคอมมิชชั่น',
    choose: 'โปรดเลือก',
    balance: 'สมดุล:',
    account: ['บัญชี', 'ใช้ได้', '/หยุด' ,'โอน'],
    dir: ['ซื้อ', 'ขาย'],
    dir2: ['ซื้อได้', 'พร้อมขาย'],
    cs: 'เลือกเอง',
    sxf: 'ค่าธรรมเนียม',
    jye: 'ยอดที่ทำรายการ',
    sc_list: ['ตลาด', 'ชื่อ', 'ราคาที่เพิ่มขึ้น'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['สกุลเงิน','ราคาล่าสุด','เพิ่มขึ้น'],
    k_line_txt: ['≈','', 'เพิ่ม', 'ราคาสูงสุด', 'ราคาต่ำสุด', 'ปริมาณ 24 ชั่วโมง'],
    tabListLTitle: ["คำสั่งปัจจุบัน", "คำสั่งประวัติศาสตร์"],
    tabListLEntrust: ["ซื้อใน", "ขาย"],
    tabListRTitle: ["การซื้อขายราคาจำกัด", "การซื้อขายราคาตลาด"],
    table_btn: ['ยกเลิกคำสั่งซื้อ'],
    index_td_l: ['เวลา' ,'วัตถุทางการค้า' ,'ปริมาณ', 'ราคา', 'การดำเนินการ'],
    index_td_r: ['ราคาล่าสุด', 'ทิศทาง', 'ราคา' ,'ปริมาณ'],
    index_td_r2: ['ธุรกรรมล่าสุด', 'เวลา', 'ราคา' ,'ปริมาณการซื้อขาย'],
    table_txt: ['สำเร็จ', 'ยกเลิกคำสั่งซื้อ'],

    db_1_txt: ['มีจำหน่าย', 'ราคาซื้อ', 'ราคาขาย', 'ปริมาณการซื้อ', 'ปริมาณการขาย', 'ปริมาณธุรกรรม', 'ซื้อในราคาที่ดีที่สุดในตลาด' ,'ขายในราคาที่ดีที่สุดในตลาด' ,'ซื้อมือ','ขายมือ'],
    db_2_txt: ['ราคา', 'เลเวอเรจ', 'โปรดเลือก', 'จำนวนล็อต', 'หนึ่งล็อตเท่ากับ', 'มือ' ,'มูลค่าตลาดตามสัญญา', 'มาร์จิ้น', 'ซื้อในราคาที่ดีที่สุดในตลาด', 'ในราคาที่ดีที่สุดในตลาด ขาย'],
    pathList: ['บันทึกสัญญา', 'บันทึกการทำธุรกรรม'],
    db_btn: ['ซื้อ (ไปยาว)', 'ขาย (สั้น)'],
    tabListLTitle2: ['คำสั่งซื้อปัจจุบัน'],

    lt_btn: ['ปิดตำแหน่งได้ด้วยคลิกเดียว','กำหนดกำไรและหยุดการขาดทุน','ปิดตำแหน่ง','ส่งทันที','คืน'],
    lt_txt: ['อัตราความเสี่ยง:','กำไรและขาดทุนของตำแหน่งทั้งหมด:'],
    lt_td: ['ประเภท', 'เลเวอเรจหลายตัว', 'ราคาตำแหน่ง', 'ราคาปัจจุบัน', 'มาร์จิ้น', 'ราคาทำกำไร', 'ราคาหยุดขาดทุน', 'เวลาเปิด', 'ล็อต', 'กำไรและขาดทุน', 'ปฏิบัติการ'],
    lt_dl: ['ตั้งราคาหยุดกำไรและหยุดขาดทุน', 'ขายทำกำไร', 'ราคาคัทลอส'],

    lt_0_btn: ['ยกเลิกคำสั่งซื้อ'],
    lt_0_td: ['ข้อมูลติดต่อ', 'สกุลเงิน', 'จำนวน', 'ราคาปัจจุบัน' ,'ค่าธรรมเนียมการจัดการ' ,'การดำเนินการ'],

    lt_1_btn: ['คัทลอส '],
    lt_1_txt: ['กำลังคัทลอส '],
    lt_1_td: ['ประเภท', 'ราคาตำแหน่ง', 'ราคาปัจจุบัน', 'มาร์จิ้น', 'ราคาทำกำไร', 'ราคาหยุดขาดทุน' ,'เวลาเปิด', 'ค่าธรรมเนียมการจัดการ' ,'กำไรและขาดทุน' ,'การดำเนินการ'],
    node_data: 'ไม่มีข้อมูล',

    lt_3_txt: ['ตำแหน่งปิด','ตำแหน่งปิด'],
    lt_3_td: ['ประเภท', 'ล็อต', 'ราคาตำแหน่ง', 'ราคาปิด' ,'ราคากำไร', 'ราคาหยุดขาดทุน', 'มาร์จิ้น' ,'มาร์จิ้นที่มีอยู่', 'เวลาเปิด', 'เวลาปิด', ' ค่าธรรมเนียมการจัดการ','กำไรขาดทุน', 'การดำเนินงาน'],

    lt_4_txt: ['ยกเลิกคำสั่งซื้อ'],
    cm: ['เวลาเปิดขาย', 'จำนวนเปิดขาย', '流通总量', '总凑价格', 'เว็บไซต์อย่างเป็นทางการ','กระดาษสีขาว','บทนำ'],
    qsrsl: 'โปรดใส่จำนวน',
    qsrss: 'กรุณาใส่ล็อต',
  },
  notice:{
      notice_title:'ศูนย์ประกาศ',
  },
  bzhl:{
    title: 'การถือส่วนลด',
    ttzbt: 'สร้างรายได้ทุกวัน',
    wdtg: 'โฮสติ้งของฉัน',
    zztgdzj: 'กองทุนภายใต้การดูแล',
    yjjrsy: 'ประมาณการทุกวัน',
    ljsy: 'รายได้สะสม',
    tgzdd: 'คำสั่งที่รอดำเนินการ',
    tgdd: 'คำสั่งเอสโครว์',
    t1: 'การจัดการทางการเงินที่มีความเสี่ยงต่ำและมีเสถียรภาพ สามารถแลกคืนได้ทุกเมื่อหากจำเป็น',
    t2: 'ผู้ช่วยจัดการเงินของคุณฟรี',
    cljxcp: 'อายุผลิตภัณฑ์',
    dbxe: 'จำกัดยอดเดียว',
    rsyl: 'ผลผลิต(%)',
    rsyl2: 'อัตราผลตอบแทนรายวัน：',
    zq: 'รายสัปดาห์',
    qmr: 'ไปซื้อ',
    ckgd: 'ดูเพิ่มเติม',
    cpgk: 'ภาพรวมผลิตภัณฑ์',
    pxsj: 'เวลาปันผล',
    tgzj: 'ทุนการดูแล',
    tqsh: 'ไถ่ถอนก่อนกำหนด',
    cpld: 'จุดเด่นของผลิตภัณฑ์',
    cpgz: 'กฎผลิตภัณฑ์',
    cont: 'การย้ายอิฐคือการโฮสต์ USDT บนแพลตฟอร์มและทีมงานมืออาชีพของแพลตฟอร์มดำเนินการสิทธิ์ในการย้ายอิฐ ผู้เข้าร่วมจะได้รับส่วนแบ่งรายได้จากการเคลื่อนย้ายอิฐของแพลตฟอร์มในช่วงระยะเวลาการดูแลกองทุน ซึ่งสามารถเข้าถึงได้ทุกเมื่อ ที่ปลอดภัยและสะดวก',
    zj: 'ทุน 100%',
    aqbz: 'ความปลอดภัย',
    jjrsy: 'รายได้วันหยุด',
    bjd: 'ไม่ขาดตอน',
    cgcrh: 'หลังฝากสำเร็จ',
    dtqx: 'วันหยุด',
    ljzr: 'โอนเลย',
    xqglgj: 'เครื่องมือจัดการเงินฟรี',
    ddh: 'เลขที่ใบสั่งซื้อ',
    tgje: 'ยอดเงินการดูแล',
    tgsj: 'รอบวัน',
    yhl: 'กำไร/วันคงเหลือ',
    xdsj: 'เวลาคำสั่งซื้อ',
    zt: 'สถานะ',
    fh: 'กลับ',
    qrnhsy: 'รายได้ต่อปีเจ็ดวัน',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: 'หยวน',
    tzfx: 'ความเสี่ยงในการลงทุน',
    shsc: 'เวลาแลกรับ',
    di: 'ต่ำ',
    yggzr: 'หนึ่งวันทำการ',
    msgsxf: 'ฟรีค่าสมัคร',
    mr: 'ทุกวัน',
    dqfh: 'ผลตอบแทนเมื่อครบกำหนด',
    ljgm: 'ซื้อทันที',
    tgz: 'ระหว่าการดูแล',
    sh: 'การไถ่ถอน',
    ywc: 'สำเร็จ',
    ysh: 'ถอนคืนแล้ว',
    all: 'ทั้งหมด',
    "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
    "qtbz": "เหรียญอื่นๆ"
  },
  pay:{
    qsrjymm: 'กรุณากรอกรหัสผ่านการทำธุรกรรม 6 หลัก',
    tbmmts: 'โปรดไปที่ศูนย์ผู้ใช้เพื่อตั้งรหัสผ่านการทำธุรกรรม',
  },
  tips:{
    qxztbdz: 'กรุณากรอกที่อยู่ถอนเงิน',
    qsrtbsl: 'โปรดใส่จำนวนการถอน'
  },
  statusText: ['ล้มเหลว','รอดำเนินการ', 'สำเร็จ'],
  dzrz: {
     title:'การตรวจสอบที่อยู่',
     sdddz:'ที่อยู่บิลค่าสาธารณูปโภค',
     zdtpsc:'อัปโหลดรูปภาพบิล',
     qsrsdddz:'คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์',
     qsczdtp:'โปรดอัปโหลดรูปภาพของใบเรียกเก็บเงิน',
     status: ['อยู่ระหว่างตรวจสอบ','ผ่านการตรวจสอบ'],
     qd:'ตกลง'
  },
  jgcc: {
    wtgd:'คำสั่งซื้อที่รอดำเนินการที่ได้รับมอบหมาย',
    cj:'ตกลง',
    jj:'แนะนำตัว',
    zc:'อยู่ในการระงับ',
    lszc:'ตำแหน่งทางประวัติศาสตร์',
    qblx:'ทุกประเภท',
    xj:'ราคาปัจจุบัน',
    sj:'เวลา',
    fx:'ทิศทาง',
    jg:'ราคา',
    sl: 'ปริมาณ',
    jgsj:'เวลาจัดส่ง',
    gmj:'ราคาซื้อ',
    jsj:'ราคาชำระ',
    yk:'กำไรขาดทุน',
    xq:'รายละเอียด',
    mz:'ซื้อขึ้น',
    md:'ซื้อลง',
    dqye:'ยอดดุลปัจจุบัน',
    gb:'ปิด',
    jxxd:'ดำเนินการสั่งซื้อต่อ',
    qrxd:'ยืนยันการสั่งซื้อ',
    ddqr:'ยืนยันการสั่งซื้อ',
    sxf:'ค่าธรรมเนียม',
    kyye:'สมดุล',
    jypz:'ชื่อ',
    jyfx:'ทิศทางการค้า',
    tzje:'จำนวนเงินลงทุน',
    tzjeTips:'จำนวนเงินลงทุนไม่สามารถเป็น 0',
    dqsj:'เวลาหมดอายุ',
    jssj:'เวลาชำระบัญชี',
    gmsj:'เวลาซื้อ',
    sy:'กำไร',
    zxje:'จำนวนขั้นต่ำ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje:'จำนวนสูงสุด ',
    qsrje:'กรุณาป้อนจำนวนเงิน',
    zxtzje:'จำนวนขั้นต่ำ',
    yebz:'ยอดเงินไม่เพียงพอ',
    xq:'รายละเอียด',
    ddz: 'รอ',
    jgjl:'บันทึกการจัดส่ง',
    bz:'สกุลเงิน',
    cz:'การทำงาน'
  },
  kjmb: {
    title:'เหรียญซื้อด่วน',
    fzcg:'คัดลอกสำเร็จ',
    ljmb:'ซื้อเหรียญทันที',
    lxkf:'ติดต่อฝ่ายบริการลูกค้า'
  },
  news: {
    title: 'ข้อความของฉัน',
    "gg": "ประกาศ",
    ckxq:'ดูรายละเอียด'
  },
  statusTabs:['คำสั่งซื้อที่รอดำเนินการ', 'กำลังดำเนินการ','คัทลอสแล้ว', 'ยกเลิกคำสั่งซื้อ'],
  "chongzhi":{
    "zy": "สำคัญ",
    "cbxx": "ข้อมูลการฝากโทเค็น",
    "qsrsl": "กรุณากรอกจำนวนเงินฝาก",
    "tips2": "1. ความเข้ากันได้กับกระเป๋าเงิน/แพลตฟอร์ม: นั่นคือ เครือข่ายได้รับการสนับสนุน หากแพลตฟอร์มเป้าหมายไม่สนับสนุนเครือข่ายการถอนเงินของคุณ สินทรัพย์จะไม่สามารถเรียกคืนได้",
    "tips3": "2. เครือข่ายเติมเงินและแพลตฟอร์มเป้าหมายเหมือนกัน หากคุณเลือกที่อยู่เป้าหมายคือเครือข่าย Ethereum แต่การเติมเงินเลือกสมาร์ทเชน TRC20 คุณอาจไม่สามารถเรียกข้อมูลสินทรัพย์ดิจิทัลของคุณได้",
    "tips4": "3. ตรวจสอบให้แน่ใจว่าที่อยู่และจำนวนเงินของคุณถูกต้องก่อนทำการชาร์จ",
    "tips5": "คำเตือน: เนื่องจากการไม่เปิดเผยตัวตนและความเป็นส่วนตัวของเครือข่ายที่ถูกบล็อก เมื่อคุณป้อนข้อมูลผิด คุณจะสูญเสียทรัพย์สินที่เกี่ยวข้อง โปรดตรวจสอบที่อยู่และปริมาณการเติมเงินของคุณอย่างระมัดระวัง",
    "tips2_1": "• โปรดอย่าเรียกเก็บเงินจากสินทรัพย์ที่ไม่ใช่สกุลเงินท้องถิ่นไปยังที่อยู่ด้านบน มิฉะนั้นจะไม่สามารถเรียกข้อมูลสินทรัพย์ได้",
    "tips2_2": "• ไม่สามารถส่งสกุลเงินดิจิทัลได้ทันเวลา เวลาที่มาถึงจริงขึ้นอยู่กับความเร็วในการยืนยันของบล็อคเชน",
    "tips2_3": "• ที่อยู่สำหรับเติมเงินของคุณจะไม่เปลี่ยนแปลงบ่อย คุณสามารถเติมเงินได้ หากมีการเปลี่ยนแปลง เราจะพยายามแจ้งให้คุณทราบผ่านทางประกาศบนเว็บไซต์หรืออีเมล",
  },
  "tibi":{
    "tbxx": "ข้อมูลการถอนเงิน",
    "qsrbq": "โปรดป้อนป้ายกำกับ",
    "tbTips1": "• เพื่อความปลอดภัยของเงิน เมื่อมีการเปลี่ยนแปลงนโยบายการรักษาความปลอดภัยของบัญชี เปลี่ยนรหัสผ่าน เราจะตรวจสอบการถอนเงินด้วยตนเอง โปรดอดทนรอเพื่อให้เจ้าหน้าที่ติดต่อคุณทางโทรศัพท์หรืออีเมล",
    "tbTips2": "• โปรดตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเบราว์เซอร์ของคุณปลอดภัยเพื่อป้องกันไม่ให้ข้อมูลถูกดัดแปลงหรือรั่วไหล",
    "tbTips3": "• สินทรัพย์ดิจิทัลที่คุณกล่าวถึงเป็นสินทรัพย์หลายสายแบบหนึ่งเหรียญ ไม่ว่าคุณจะเลือกเพิ่มจากสายใด หมายความว่าจำนวนสินทรัพย์ดิจิทัลทั้งหมดที่แสดงในหน้าถอนเงินที่คุณเป็นเจ้าของจะลดลง ตามจำนวนเงินที่เพิ่ม .",
  },
  "gjlb": "รายการประเทศ",
  "qxzgjlb": "กรุณาเลือกประเทศ / ภูมิภาค",
  "mbwt":{
    "title": "การตั้งค่าคำถามความปลอดภัยลับ",
    "mbwt": "คำถามเพื่อความปลอดภัย",
    "problem":[
      {
        "id": 1,
        "title": "ใครคือเพื่อนที่ดีที่สุดของคุณ?"
      },
      {
        "id": 2,
        "title": "ไอดอลของคุณคือใคร?"
      },
      {
        "id": 3,
        "title": "ที่ไหนที่คุณโหยหามากที่สุด?"
      }
    ],
    "qtxda": "โปรดใส่คำตอบ",
    "qsrxmm": "กรุณาใส่รหัสผ่านใหม่",
    "qqrmm": "โปรดยืนยันรหัสผ่าน",
    "sydqmmcz": "ใช้รหัสผ่านปัจจุบันในการรีเซ็ต",
    "zhmm": "ปัญหาด้านความปลอดภัย เรียกรหัสผ่าน",
    "ysz": "ตั้งค่าแล้ว",
    "tg": "ข้าม",
    "tj": "ส่ง",
    "zyts": "สำคัญ:",
    "zytsCont": "อย่าเปิดเผยคำตอบลับและรหัสยืนยัน และคำนึงถึงปัญหาด้านความปลอดภัยซึ่งจะช่วยให้คุณดึงรหัสผ่านของคุณ"
  },
  "zc":{
    "zclb": "รายการสินทรัพย์",
    "zczh": "การแปลงสินทรัพย์",
    "yczc": "ซ่อนยอดคงเหลือที่เป็น0"
  },
  "indexNew":{
    "t1": "ผู้นำระดับโลก",
    "t2": "แพลตฟอร์มบริการสินทรัพย์ดิจิทัล",
    "t3": "ทำธุรกรรมสินทรัพย์ดิจิทัลบล็อคเชนแบบครบวงจร",
    "t4": "หมายเลขโทรศัพท์มือถือ/อีเมล",
    "t5": "ลงทะเบียนเลย",
    "t6": "ยินดีต้อนรับลูกค้าจากทั่วทุกมุมโลกผ่าน GMO Global",
    "t7":"ค้นพบและเริ่มต้นเส้นทางการเข้ารหัส"
  },
  "newReg":{
    "dl": ['อีเมล','มือถือ'],
    "cjzh": "สร้างบัญชี",
    "sysjhzyx": "ลงทะเบียนด้วยเบอร์มือถือ/อีเมล",
    "yhxy": "&lt;ข้อตกลงผู้ใช้&gt;",
    "yhxy2": "ฉันได้อ่านและยอมรับและ &lt;ข้อตกลงผู้ใช้&gt; ",
    "yxgz": "กรุณาใส่อีเมลที่ถูกต้อง",
    "dhgz": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง"
  },
  "indexNew2":{
    "t1": "ซื้อขายตามคำสั่งของเรา",
    "t2": "ใช้ Bitbank",
    "t3": "Bitbank คือการแลกเปลี่ยน bitcoin และสินทรัพย์เข้ารหัสที่ออกแบบมาอย่างชาญฉลาด มันง่ายมาก สะดวก ปลอดภัย และมีประสิทธิภาพ รองรับธุรกรรมบนเว็บและแพลตฟอร์มสมาร์ทโฟนที่หลากหลาย ข้อมูลธุรกรรมและแผนภูมิได้รับการอัปเดตแบบเรียลไทม์ ครอบคลุม การวิเคราะห์ราคาตลาดมีเครื่องมือวิเคราะห์ทางเทคนิคมากกว่า 60 รายการ เริ่มซื้อขาย",
    "ksjy": "เริ่มซื้อขาย",
    "ly": "5 เหตุผลที่ควรเลือก Bitbank",
    "item1_t1": "ปริมาณการซื้อขายชั้นนำ",
    "item1_t2": "อันดับ 1 * ปริมาณการซื้อขายสินทรัพย์ Crypto",
    "item1_t3": "การซื้อขายที่มีสภาพคล่องสูง สะดวกสบาย (ประสบการณ์การซื้อขายที่น่าพอใจ) แสดงรายการสินทรัพย์ดิจิทัล 12 ประเภท",
    "item2_t1": "การประเมินโดยบุคคลที่สามในระดับสูง",
    "item2_t2": "สภาพแวดล้อมการซื้อขายที่ปลอดภัย",
    "item2_t3": "ใช้ cold wallet ออฟไลน์ ใช้ Multisig เพื่อป้องกันไม่ให้แฮ็กเกอร์ ปกป้องทรัพย์สินของคุณด้วยเทคโนโลยีขั้นสูง",
    "item3_t1": "แอปพลิเคชั่นที่ใช้งานง่ายและเชื่อถือได้",
    "item3_t2": "ใช้งานง่ายและใช้งานง่าย",
    "item3_t3": "แอปพลิเคชันที่เชื่อถือได้พร้อมฟังก์ชันที่หลากหลาย สามารถรักษาโอกาสในการซื้อขายนอกธุรกรรมได้",
    "item4_t1": "เปิดทั้งวัน",
    "item4_t2": "ฝากทองได้",
    "item4_t3": "รองรับการฝากเงินตลอด 24 ชั่วโมง รวมถึงวันหยุดด้วย!",
    "item5_t1": "สมาร์ทโฟนและพีซี",
    "item5_t2": "การออกแบบที่มีมนุษยธรรม",
    "item5_t3": "แม้ว่าคุณจะใช้สมาร์ทโฟน คุณก็สามารถทำธุรกรรมที่ง่ายและผ่านการรับรองได้โดยไม่ลังเล",
    "aqkk": "ปลอดภัยและเชื่อถือได้",
    "aqkk2": "ธุรกรรม Bitbank Bitcoin",
    "cjzh": "สร้างบัญชี",
  },
  "xbsg":{
    "title": "เหรียญใหม่",
    "wdsg": "รายละเอียด",
    "scts": "วันกักตัว: ",
    "sy": "ที่เหลืออยู่",
    "ljsg": "สมัครสมาชิกตอนนี้",
    "ysk": "ขายหมดแล้ว",
    "xzjdy": "สมัครสมาชิกตอนนี้",
    "dy": "ติดตาม",
    "fxjg": "ออกราคา",
    "fxl": "การไหลเวียน",
    "ssrq": "วันที่ลงรายการ",
    "yxqx": "ระยะเวลาที่ใช้ได้",
    "qsrsl": "กรุณาระบุจำนวนเงิน",
    "syl": "ที่เหลืออยู่",
    "sgrq": "ติดตาม",
    "sgsl": "จำนวน",
    "bz": "เหรียญ",
    "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
    "tgsl": "ผ่านจำนวน",
    "shz": "ภายใต้การทบทวน",
    "wtg": "ไม่ผ่าน",
    "ytg": "ผ่านไป"
  },
  "wydb":{
    "title": "ยืม",
    "db": "ยืม",
    "dbz": "ยืม",
    "jl": "บันทึก",
    "jdzq": "ระยะเวลา (วัน)",
    "qhk": "เพื่อชำระคืน",
    "ljdb": "สะสม(usdt)",
    "dhkbs" :"ที่รอดำเนินการชำระเงิน",
    "jkje": "วงเงินกู้(usdt)",
    "qsrje": "กรุณาระบุจำนวนเงิน",
    "rll": "อัตราดอกเบี้ยรายวัน",
    "hkfs": "การชำระคืน",
    "dqych": "หมดอายุ",
    "lx": "ความสนใจ",
    "fkjg": "ผู้ให้กู้",
    "tpsc": "สินเชื่อเงินกู้ (อัพโหลดรูปภาพ)",
    "fwxx": "ข้อมูลที่อยู่อาศัย",
    "srzm": "หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
    "yhmx": "รายการเงินฝากถอนในบัญชีเงินฝาก",
    "zjz": "รูปถ่ายประจำตัว",
    "yd": "ฉันได้อ่านและตกลง",
    "xy": "สมัครสัญญาเงินกู้",
    "sqdb": "สมัครกลุ่มสินเชื่อ",
    "gb": "ปิด",
    "qd": "ตกลง",
    "ts": "โปรดตรวจสอบ สมัครสัญญาเงินกู้",
    "dbjl": "บันทึก",
    "hkhth": "รหัสการสั่งซื้อ",
    "wsh": "ยังไม่ได้ตรวจสอบ",
    "yfk": "เงินกู้",
    "sqrq": "เวลาสมัคร",
    "zq": "วงจร",
    "dbsl": "จำนวนซี่โครง",
    "zhke": "การชำระเงินทั้งหมด",
    "yhkxq": "รายละเอียดการชำระคืน",
    "bqyhk": "ชำระคืนในงวดปัจจุบัน(USDT)",
    "hktips": "กรุณาตรวจสอบให้แน่ใจว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วจึงค่อยชำระคืน",
    "bj": "อาจารย์ใหญ่",
    "jie": "ยืม",
    "ljhk": "ชำระคืนทันที",
    "qcz": "การฝาก",
    "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วค่อยชำระคืน",
    "znj": "ค่าธรรมเนียมการชำระล่าช้า",
    "yqts": "วันที่เกินกำหนด"
  },
  "hkxq":{
    "dd":"คำสั่ง",
    "fzhkdz":"คัดลอกที่อยู่การชำระเงิน",
    "hkxq": "รายละเอียดการชำระคืน",
    "zlx": "ดอกเบี้ยทั้งหมด",
    "zhk": "ชำระคืนทั้งหมด",
    "hkjg": "หน่วยงานการชำระคืน",
    "hkpz": "ใบรับรองการชำระหนี้"
  },
  "bbjyNew":{
    "jylx": "ชนิดของ",
    "jyze": "จำนวน"
  },
  "bind":{
    "title": "การตรวจสอบอีเมล",
    "ybd": "ผูกพัน",
    "wbd": "หลุด",
    "ts": "เพื่อปกป้องบัญชีของคุณ ขอแนะนำให้ผูกที่อยู่อีเมล",
    "qsryxdz": "ที่อยู่อีเมล"
  },
  "tipsNew": {
    "yjj": "ถูกปฏิเสธ",
    "shz": "การไถ่ถอน"
  },
  "newIndex2":{
    "zxhy": "ราคาล่าสุด",
    "jypt": "แพลตฟอร์มการซื้อขาย",
    "dqwz": "ตำแหน่งปัจจุบัน",
    "yzm": "รหัสยืนยัน",
    "qrmm": "ยืนยันรหัสผ่าน",
    "djdl": "คลิกเพื่อเข้าสู่ระบบ",
    "ghdjy": "ข้อตกลงที่ดีกว่า",
    "ghdsh": "ชีวิตที่ดีขึ้น",
    "เกี่ยวกับ": "ศูนย์แลกเปลี่ยน crypto ที่ล้ำสมัยที่สุดในโลกอยู่ที่นี่ ที่ซึ่งคุณสามารถซื้อ แลกเปลี่ยน และรับ cryptocurrencies ด้วย cryptocurrencies นับร้อยที่ปลายนิ้วของคุณ",
    "index01": "ประตูสู่ Bitcoin และอื่น ๆ ของคุณ",
    "index02": "แพลตฟอร์มบริการสินทรัพย์ดิจิทัลชั้นนำของโลก",
    "index03": "ธุรกรรมทั้งหมดฟรี",
    "index04": "ค่าธรรมเนียมการเปิดบัญชี, ค่าบำรุงรักษาบัญชี, ค่าธรรมเนียมหยุดการขาดทุน, ค่าธรรมเนียมการฝาก, ค่าธรรมเนียมการจัดเก็บ/จัดส่งทั้งหมดฟรี",
    "index05": "การรักษาความปลอดภัยที่ปลอดภัย",
    "index06": "การใช้ความเชี่ยวชาญที่ GMI INT ได้สั่งสมมาตั้งแต่เริ่มก่อตั้ง เรากำลังสร้างระบบที่แข็งแกร่งและใช้มาตรการรักษาความปลอดภัยต่างๆ เพื่อปกป้องทรัพย์สินของลูกค้าของเราอย่างปลอดภัย",
    "index07": "มีทั้งการซื้อขายจริงและการซื้อขายแบบเลเวอเรจ",
    "index08": "ธุรกรรมขนาดเล็กสามารถทำได้จากประมาณ $10 สเปรดนั้นแคบที่สุดในอุตสาหกรรม และยอดคงเหลือในบัญชีสามารถใช้เป็นหลักประกันสำหรับธุรกรรมที่มีเลเวอเรจ เฉพาะ GMI INT เท่านั้นที่สามารถเรียกเก็บค่าธรรมเนียมเลเวอเรจได้",
    "index09": "โทเค็นที่ออกแบบมาเพื่อเสริมพลังให้กับชุมชน GMI INT",
    "index10": "Unus Sed LEO เป็นโทเค็นของแอปพลิเคชันที่ออกแบบมาเพื่อช่วยเหลือผู้ใช้ที่ต้องการเพิ่มประโยชน์และฟังก์ชันของแพลตฟอร์มการซื้อขาย GMI INT ให้มากที่สุดตรงตามความต้องการ",
    "index11": "โทเค็นที่ออกแบบมาเพื่อเสริมพลังให้กับชุมชน GMI INT",
    "index12": "เปิดทางสู่ชีวิตที่ดีขึ้น",
    "index13": "ทุกคนสามารถเป็นเจ้าของ crypto ได้ ทุกคนสามารถแลกเปลี่ยนซอฟต์แวร์ crypto ได้ นี่คือวิธีที่ Bitget สามารถพาคุณไปอีกขั้นได้",
    "index14": "ผลิตภัณฑ์นวัตกรรม",
    "index15": "คลิกเดียวก็อปปี้เทรด",
    "index16": "ห้ามแปลงโทเค็นเมื่อทำการซื้อขาย",
    "index17": "ตลาดซื้อขายล่วงหน้ารายใหญ่ที่รองรับมาร์จิ้น USDC",
    "index18": "การควบคุมความเสี่ยงผ่านการแยกกระเป๋าสตางค์ร้อนและเย็น",
    "index19": "การให้คะแนน 12 a+ จาก SSL Labs",
    "index20": "การรักษาความปลอดภัยที่เชื่อถือได้รองรับโดย Suntwin Technology, Green Pine Cloud Security, HEAP และ Armors",
    "index21": "บริการลูกค้าเป็นเลิศ",
    "index22": "สนับสนุนออนไลน์ทุกวันตลอด 24 ชั่วโมงในหลายภาษา",
    "index23": "รองรับลูกค้าวีไอพีแบบตัวต่อตัว",
    "index24": "ศูนย์รางวัลชุมชน",
    "index25": "สร้างโดยเทรดเดอร์เพื่อเทรดเดอร์",
    "index26": "ซื้อขายสินทรัพย์ดิจิทัลต่างๆ เช่น Bitcoin, Ethereum, Solana และ dogcoin ด้วยต้นทุนการทำธุรกรรมต่ำ",
    "index27": "เครื่องมือและข้อมูลที่คุณต้องการในการซื้อ ขาย แลกเปลี่ยน ลงทุน และใช้สกุลเงินดิจิทัล",
    "index28": "ความปลอดภัยระดับแนวหน้าของอุตสาหกรรม",
  },
  "langNew":{
    "szhb": "สกุลเงินดิจิทัล",
    "gjs": "โลหะ",
    "yy": "น้ำมันดิบ",
    "jy": "ซื้อขาย",
    "jmhb": "สกุลเงินดิจิทัล",
    "yxhy": "สัญญาถาวร",
    "gdjy": "คำสั่งซื้อที่รอดำเนินการ",
    "khh": "ธนาคารบัญชี",
    "qsrkhh": "กรุณากรอกธนาคาร",
    "yhkh": "บัญชีธนาคาร",
    "qsryhkh": "กรุณาใส่เลขบัญชีธนาคาร",
    "mnzh":"บัญชีทดลอง",
    "cjmnzhcg":"สร้างบัญชีทดลองสำเร็จแล้ว",
    "tcmnzh":"ออกจากบัญชีทดลอง",
   }
}



// WEBPACK FOOTER //
// ./src/lang/th.js